import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconHeadphones = ({
  className,
  size = "md"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={`${className} ${sizeOption}`}
  >
    <defs>
      <path
        d="M18,19 C16.897,19 16,18.103 16,17 C16,15.897 16.897,15 18,15 C19.103,15 20,15.897 20,17 C20,18.103 19.103,19 18,19 M6,15 C7.103,15 8,15.897 8,17 C8,18.103 7.103,19 6,19 C4.897,19 4,18.103 4,17 C4,15.897 4.897,15 6,15 M12,2 C6.486,2 2,6.65 2,12.366 L2,17 C2,19.206 3.794,21 6,21 C8.206,21 10,19.206 10,17 C10,14.794 8.206,13 6,13 C5.268,13 4.591,13.212 4,13.557 L4,12.366 C4,7.753 7.589,4 12,4 C16.411,4 20,7.753 20,12.366 L20,13.557 C19.409,13.212 18.732,13 18,13 C15.794,13 14,14.794 14,17 C14,19.206 15.794,21 18,21 C20.206,21 22,19.206 22,17 L22,12.366 C22,6.65 17.514,2 12,2"
        id="path-at7-_cn7sf-1"
      />
    </defs>
    <g
      id="\u2B50\uFE0F-[Symbols]-Icons"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon/headphones">
        <mask id="mask-at7-_cn7sf-2" fill="white">
          <use xlinkHref="#path-at7-_cn7sf-1" />
        </mask>
        <use
          id="\uD83C\uDFA8-Icon-\u0421olor"
          fill="#262935"
          xlinkHref="#path-at7-_cn7sf-1"
        />
      </g>
    </g>
  </svg>
  )
}
